import React from 'react';
import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

import { Modal, toast, Button as DsButton, Tag } from '../../components/ds';
import * as funcionarioAPI from '../../api/funcionarios';

// Lista de CBOs da cota de jovem aprendiz (CLT art. 429).
//
// Só a lista decide: entra na base o CLT ativo, que não é aprendiz, com um
// CBO (ocupação, 6 dígitos) marcado aqui como "Entra". CBO fora da lista fica
// fora da base. A lista nasceu com os CBOs do cadastro marcados pela regra
// antiga (grandes grupos 1 e 2 e família 3121 fora); o DP ajusta aqui,
// conferindo no site da CBO o campo "Formação e experiência".
//
// Props: open, onClose, onAlterado(regras) — chamado depois de cada gravação
// com a lista nova, para a tela refazer a conta da cota.

const formatarCbo = (cbo) => {
  const d = String(cbo || '').replace(/\D/g, '');
  return d.length === 6 ? `${d.slice(0, 4)}-${d.slice(4)}` : d;
};

const ehVerdadeiro = (v) => v === true || v === 't' || v === 'true';

const mensagemErro = (e, padrao) => (e && e.response && e.response.message) || padrao;

const celula = { padding: '6px 8px', borderBottom: '1px solid rgba(0,0,0,0.06)' };
const cabecalho = { ...celula, textAlign: 'left', borderBottom: '1px solid #e0e0e0', fontWeight: 500 };

class CboAprendizModal extends React.Component {
  state = {
    carregando: false,
    salvando: false,
    lista: [],
    semRegra: [],
    cboInvalido: 0,
    novoCbo: '',
    novaDescricao: '',
    novoEntra: 'sim'
  };

  componentDidUpdate(anterior) {
    if (this.props.open && !anterior.open) this.carregar();
  }

  carregar = () => {
    this.setState({ carregando: true });
    return funcionarioAPI
      .getCboAprendiz()
      .then((r) => {
        const lista = r.request || [];
        this.setState({
          carregando: false,
          lista,
          semRegra: r.sem_regra || [],
          cboInvalido: r.cbo_invalido || 0
        });
        return lista;
      })
      .catch((e) => {
        this.setState({ carregando: false });
        toast.error(mensagemErro(e, 'Não foi possível carregar os CBOs.'));
        return null;
      });
  };

  depoisDeGravar = () =>
    this.carregar().then((lista) => {
      if (lista && this.props.onAlterado) this.props.onAlterado(lista);
    });

  salvar = (cbo, descricao, entra) => {
    this.setState({ salvando: true });
    return funcionarioAPI
      .salvarCboAprendiz(cbo, descricao, entra)
      .then(() => {
        this.setState({ salvando: false });
        return this.depoisDeGravar();
      })
      .catch((e) => {
        this.setState({ salvando: false });
        toast.error(mensagemErro(e, 'Não foi possível salvar o CBO.'));
        throw e;
      });
  };

  adicionar = () => {
    const digitos = this.state.novoCbo.replace(/\D/g, '');
    if (digitos.length !== 6) {
      toast.error('Informe os 6 dígitos da ocupação (ex.: 4110-10).');
      return;
    }
    if (this.state.lista.some((c) => c.cbo === digitos)) {
      toast.error(`O CBO ${formatarCbo(digitos)} já está na lista; altere na linha dele.`);
      return;
    }
    this.salvar(digitos, this.state.novaDescricao, this.state.novoEntra === 'sim')
      .then(() => this.setState({ novoCbo: '', novaDescricao: '', novoEntra: 'sim' }))
      .catch(() => {});
  };

  trocarEntra = (linha) => (evento) => {
    this.salvar(linha.cbo, linha.descricao || '', evento.target.value === 'sim').catch(() => {});
  };

  remover = (linha) => {
    this.setState({ salvando: true });
    funcionarioAPI
      .removerCboAprendiz(linha.cbo)
      .then(() => {
        this.setState({ salvando: false });
        this.depoisDeGravar();
      })
      .catch((e) => {
        this.setState({ salvando: false });
        toast.error(mensagemErro(e, 'Não foi possível remover o CBO.'));
      });
  };

  // CBO do cadastro que ainda não está na lista: entra com o cargo como
  // descrição, marcado como "Entra" (dá para trocar logo em seguida).
  adicionarDoCadastro = (item) => {
    this.salvar(item.cbo, item.cargo || '', true).catch(() => {});
  };

  render() {
    const { open, onClose } = this.props;
    const { carregando, salvando, lista, semRegra, cboInvalido } = this.state;
    const entram = lista.filter((c) => ehVerdadeiro(c.entra_calculo));
    const pessoasNaBase = entram.reduce((s, c) => s + Number(c.pessoas || 0), 0);

    return (
      <Modal isOpen={open} onClose={onClose} title="CBOs do jovem aprendiz" maxWidth="md" fullWidth>
        <p style={{ marginTop: 0, color: '#666' }}>
          Entra na base da cota quem é CLT ativo, não é aprendiz e tem um CBO marcado como
          "Entra". CBO fora da lista não conta. Hoje: {entram.length} CBO(s) entram,
          somando {pessoasNaBase} pessoa(s).
        </p>

        <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'flex-end', gap: 12, marginBottom: 16 }}>
          <TextField
            label="CBO (6 dígitos)"
            placeholder="4110-10"
            value={this.state.novoCbo}
            onChange={(e) => this.setState({ novoCbo: e.target.value.slice(0, 9) })}
            style={{ width: 150 }}
          />
          <TextField
            label="Descrição (opcional)"
            value={this.state.novaDescricao}
            onChange={(e) => this.setState({ novaDescricao: e.target.value.slice(0, 255) })}
            style={{ flex: 1, minWidth: 200 }}
          />
          <Select value={this.state.novoEntra} onChange={(e) => this.setState({ novoEntra: e.target.value })}>
            <MenuItem value="sim">Entra no cálculo</MenuItem>
            <MenuItem value="nao">Não entra</MenuItem>
          </Select>
          <DsButton intent="primary" disabled={salvando} onClick={this.adicionar}>
            Adicionar
          </DsButton>
        </div>

        {semRegra.length > 0 ? (
          <div style={{ background: '#FFF6E5', padding: '8px 12px', borderRadius: 4, marginBottom: 16 }}>
            <div style={{ fontSize: 13, marginBottom: 6 }}>
              CBOs no cadastro de CLT ativos que não estão na lista (essas pessoas ficam fora da base):
            </div>
            {semRegra.map((s) => (
              <span key={s.cbo} style={{ display: 'inline-flex', alignItems: 'center', marginRight: 12, marginBottom: 4 }}>
                <strong>{formatarCbo(s.cbo)}</strong>
                <span style={{ margin: '0 6px', color: '#666' }}>
                  {s.cargo || 'sem cargo'} ({s.pessoas})
                </span>
                <DsButton intent="text" disabled={salvando} onClick={() => this.adicionarDoCadastro(s)}>
                  Adicionar
                </DsButton>
              </span>
            ))}
          </div>
        ) : null}

        {cboInvalido > 0 ? (
          <p style={{ color: '#8a6d3b', fontSize: 13 }}>
            {cboInvalido} CLT ativo(s) estão sem CBO ou com CBO incompleto no cadastro e ficam fora da base.
          </p>
        ) : null}

        {carregando ? (
          <p>Carregando...</p>
        ) : lista.length === 0 ? (
          <p>Nenhum CBO na lista: ninguém entra na base da cota.</p>
        ) : (
          <div style={{ maxHeight: 380, overflowY: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr>
                  {['CBO', 'Descrição', 'Pessoas', 'Cálculo', 'Alterado por', ''].map((t) => (
                    <th key={t} style={cabecalho}>{t}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {lista.map((c) => (
                  <tr key={c.cbo}>
                    <td style={{ ...celula, whiteSpace: 'nowrap' }}>{formatarCbo(c.cbo)}</td>
                    <td style={celula}>{c.descricao || '—'}</td>
                    <td style={celula}>{Number(c.pessoas || 0)}</td>
                    <td style={celula}>
                      <Select
                        value={ehVerdadeiro(c.entra_calculo) ? 'sim' : 'nao'}
                        onChange={this.trocarEntra(c)}
                        disabled={salvando}
                        renderValue={(v) => (
                          <Tag tone={v === 'sim' ? 'green' : 'grey'} dot={false}>
                            {v === 'sim' ? 'Entra' : 'Não entra'}
                          </Tag>
                        )}
                      >
                        <MenuItem value="sim">Entra</MenuItem>
                        <MenuItem value="nao">Não entra</MenuItem>
                      </Select>
                    </td>
                    <td style={{ ...celula, fontSize: 12, color: '#666' }}>
                      {c.atualizado_por === 'migracao' ? 'Regra antiga' : c.atualizado_por || '—'}
                    </td>
                    <td style={celula}>
                      <DsButton intent="text" disabled={salvando} onClick={() => this.remover(c)}>
                        Remover
                      </DsButton>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        <div style={{ marginTop: 16, display: 'flex', justifyContent: 'flex-end' }}>
          <DsButton intent="primary" onClick={onClose}>Fechar</DsButton>
        </div>
      </Modal>
    );
  }
}

export default CboAprendizModal;
